module.exports = __webpack_public_path__ + "img/flecha-hacia-abajo.a5060883.svg";